import { Controller } from "@hotwired/stimulus"

import { storedUser } from "@/helpers/current_user"

export default class extends Controller {
  static targets = ["loginSection", "logoutSection", "profileMenuButton", "userName"]

  declare readonly loginSectionTargets: HTMLElement[]
  declare readonly logoutSectionTarget: HTMLElement
  declare readonly hasLogoutSectionTarget: boolean
  declare readonly profileMenuButtonTarget: HTMLButtonElement
  declare readonly userNameTarget: HTMLElement

  connect(): void {
    this.render()
  }

  render(): void {
    const user = storedUser()

    if (user) {
      this.profileMenuButtonTarget.hidden = false
      this.loginSectionTargets.forEach((target) => (target.hidden = true))

      // logoutSection lives in the burger-menu modal, which is only rendered when display_navbar?
      // is true — so the target is absent on pages without the nav (e.g. checkout, medical info form).
      if (this.hasLogoutSectionTarget) {
        this.logoutSectionTarget.hidden = false
      }

      if (user.firstName) {
        this.profileMenuButtonTarget.textContent = user.firstName.charAt(0)
        this.userNameTarget.textContent = user.firstName
      }
    }
  }
}
